import { Injectable } from "@angular/core";
import { WebApiService } from "../../_libs/web-api";
import { EnvConfigProvider } from "../_core/services/env-config.provider";
import { LocalStorageService } from "../../@dodo/local-storage/trycatch-local-storage.service";
import { LocalStorageKeys } from "../_core/services/local-storage-state-restor.service";
import { Router } from "@angular/router";
import { BaseWebApiService } from "../_core/services/-base-webapi.service";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { DodoService } from "app/_core/services/models/dodo-service.model";

@Injectable({
	providedIn: "root"
})
export class KioskService extends BaseWebApiService {
	private targetPathMap = {
		internet: "internet",
		mobile: "mobile/plans",
		energy: "energy"
	};

	constructor(
		private __router: Router,
		private __localStore: LocalStorageService
	) {
		super();
	}

	targetPath(target: string): string {
		return this.targetPathMap[target];
	}

	storeKiosk(kiosk: Auth0User) {
		this.__localStore.setInLocalStorage(LocalStorageKeys.kiosk, kiosk);
	}

	storeKioskSelectedService(service: DodoService) {
		const kiosk = this.getKiosk();
		kiosk.service = service;
		this.storeKiosk(kiosk);
	}

	getKiosk(): Auth0User {
		return <Auth0User>(
			this.__localStore.getFromLocalStorage(LocalStorageKeys.kiosk)
		);
	}

	deleteKiosk() {
		this.__localStore.deleteFromLocalStorage(LocalStorageKeys.kiosk);
	}

	navigateUserToTarget(target: string) {
		this.__router.navigate([this.targetPath(target)]);
	}

}
